import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-save-payment',
  templateUrl: './confirm-save-payment.component.html',
  styleUrls: ['./confirm-save-payment.component.css']
})
export class ConfirmSavePaymentComponent implements OnInit {


  innerHeight: number = window.innerHeight;
  loader: boolean = false;
  currentPaySavStripe: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    public dialogRef: MatDialogRef<ConfirmSavePaymentComponent>,
  ) {


    this.currentPaySavStripe = data.currentPaySavStripe
  }

  ngOnInit(): void {
  }

  closeDial(data?:any): void {
    this.dialogRef.close();
  }

  savePayment(data:any): void {

    this.dialogRef.close(data);


 
  }


}
